import { siteConst } from "../constants/siteConst";

const initialState = {
  responseData: {},
  formList:{},
  formStatus:{},
  apiDetail:{},
  settingStatus:{},
  role:{},
  rstatus:{},
  ssl: {},
};

export default function siteReducer(state = {}, action) {

  switch (action.type) {
    case siteConst.GET_CUSTOMER_DATA_REQUEST:
      return {
         ...state, 
        loading: true
      };
    case siteConst.GET_CUSTOMER_DATA_SUCCESS:
      return {...state, searchData: action.responseData.data, loading: false };
    case siteConst.GET_CUSTOMER_DATA_FAILURE:
      return {
         ...state, 
        error: action.error,
        loading: false
      };
    case siteConst.GET_LOOKUP_DATA_REQUEST:
      return {
         ...state, 
        loading: true
      };
    case siteConst.GET_LOOKUP_DATA_SUCCESS:
      return {...state, responseData: action.responseData.data, loading: false, lookupType: action.lookupType };
    case siteConst.GET_LOOKUP_DATA_FAILURE:
      return {
         ...state, 
        error: action.error,
        loading: false
      };
    case siteConst.GETCOUNTRY_REQUEST:
      return {
        loading: true
      };
    case siteConst.GETCOUNTRY_SUCCESS:
      return {
        items: action.users
      };
    case siteConst.GETCOUNTRY_FAILURE:
      return {
        error: action.error
      };
    case siteConst.GET_SITE_DETAILS_REQUEST:
      return {
        loading: true
      };
    case siteConst.GET_SITE_DETAILS_SUCCESS:
      return {
        siteDetails: action.responseData.data
      };
    case siteConst.GET_SITE_DETAILS_FAILURE:
      return {
        error: action.error
      };
    case siteConst.UPDATE_SITE_REQUEST:
      return {
        loading: true
      };
    case siteConst.UPDATE_SITE_SUCCESS:
      return {
        updatedSiteDetails: action.responseData
      };
    case siteConst.UPDATE_SITE_FAILURE:
      return {
        error: action.error
      };
    case siteConst.GET_DASHBOARD_DETAILS_REQUEST:
      return {
         ...state, 
        loading: true
      };
    case siteConst.GET_DASHBOARD_DETAILS_SUCCESS:
      return {...state, dashboardData: action.responseData.data, loading: false };
    case siteConst.GET_DASHBOARD_DETAILS_FAILURE:
      return {
         ...state, 
        error: action.error,
        loading: false
      };
    case siteConst.CHECK_SITE_STATUS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.CHECK_SITE_STATUS_SUCCESS:
      return {
        ...state,
        siteStatus: action.responseData.data,
        loading: false
      };
    case siteConst.CHECK_SITE_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case siteConst.GET_FORMSETTING_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.GET_FORMSETTING_SUCCESS:
      return {
        ...state,
        formList: action.responseData.data,
        loading: false
      };
    case siteConst.GET_FORMSETTING_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
     case siteConst.POST_FORMSETTING_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.POST_FORMSETTING_SUCCESS:
      return {
        ...state,
        formStatus: action.responseData,
        loading: false
      };
    case siteConst.POST_FORMSETTING_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case siteConst.GET_APISETTING_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.GET_APISETTING_SUCCESS:
      return {
        ...state,
        apiDetail: action.responseData,
        loading: false
      };
    case siteConst.GET_APISETTING_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case siteConst.POST_APISETTING_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.POST_APISETTING_SUCCESS:
      return {
        ...state,
        settingStatus: action.responseData,
        loading: false
      };
    case siteConst.POST_APISETTING_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case siteConst.POST_ROLELIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.POST_ROLELIST_SUCCESS:
      return {
        ...state,
        role: action.responseData,
        loading: false
      };
    case siteConst.POST_ROLELIST_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case siteConst.POST_ROLESTATUS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.POST_ROLESTATUS_SUCCESS:
      return {
        ...state,
        rstatus: action.responseData,
        loading: false
      };
    case siteConst.POST_ROLESTATUS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case siteConst.POST_SSL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case siteConst.POST_SSL_SUCCESS:
      return {
        ...state,
        ssl: action.responseData,
        loading: false
      };
    case siteConst.POST_SSL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/siteReducer.js